import moment from 'moment'

export const formatDate = (timestamp?: number) => {
  if (!timestamp) return ''
  return moment(timestamp * 1000).format('DD-MM-YYYY')
}

export const formatDateYYYYMMDD = (date?: string) => {
  if (!date) return '';
  return moment(date, 'DD-MM-YYYY')?.format('YYYY-MM-DD');
}

// convert 2024-10-10T06:28:28.451Z to 10 - 10 - 2024 13:28
// if date == currentDate show 13:28
export const dateTimeForChat = (dateString?: string) => {
  if (!dateString) return '';
  const momentDate = moment(dateString);
  const today = moment();
  if (momentDate.isSame(today, 'day')) {
    return momentDate.format('HH:mm');
  } else {
    return momentDate.format('DD-MM-YY HH:mm');
  }
}
